import { render, staticRenderFns } from "./inventario-bodega.vue?vue&type=template&id=7012ef16"
import script from "./inventario-bodega.vue?vue&type=script&lang=js"
export * from "./inventario-bodega.vue?vue&type=script&lang=js"
import style0 from "./inventario-bodega.vue?vue&type=style&index=0&id=7012ef16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports